import React, { useState, useEffect, Fragment } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FiEdit2, FiTrash2 } from "react-icons/fi";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import HandleHttpErrors from "../../HandleHttpErrors";
import { Row, Col, Table, Spinner } from "react-bootstrap";
import Edit from "./Edit";
import ErrorModal from "../../ErrorModal";
import DeleteConfirmation from "../../shared/DeleteConfirmation";
import GetParsedDate from "../../shared/GetParsedDate";

const baseURL = process.env.REACT_APP_API_JOBS;

const Listdelete = ({ increment, counter, setCounter, moamad_id }) => {
  const [moamadootNotes, setMoamadootNotes] = useState(null);
  const [moamadootNoteId, setMoamadootNoteId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorHeader, setErrorHeader] = useState("");
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getData = async () => {
      try {
        const response = await axiosPrivate.get(
          baseURL + "moamadootnote?moamad_id=" + moamad_id,
          {
            signal: controller.signal,
          }
        );
        isMounted && setMoamadootNotes(response.data);
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    getData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [counter]);

  const handleEditClick = (event, moamadootNote) => {
    event.preventDefault();
    setMoamadootNoteId(moamadootNote.id);
  };
  const handleCancelClick = () => {
    setMoamadootNoteId(null);
  };

  if (!moamadootNotes) return null;
  if (loading) {
    // Render a spinner while the data is loading
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" variant="danger" visible />

          <br />
          <br />
          <h3 className="spinnerText">המתן עד סיום הפעולה.</h3>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div>
          <Row>
            <Col sm="10" md={{ size: 3, offset: 1 }}>
              <form onSubmit={increment}>
                <Table hover>
                  <thead>
                    <tr>
                      <th>מספר הערה</th>
                      <th>תאריך</th>
                      <th>משתמש קולט </th>
                      <th>הערה</th>
                    </tr>
                  </thead>
                  <tbody>
                    {moamadootNotes?.map((moamadootNote) => (
                      <Fragment key={moamadootNote.id}>
                        {moamadootNoteId === moamadootNote.id ? (
                          <Edit
                            moamadootNote={moamadootNote}
                            handleCancelClick={handleCancelClick}
                            increment={increment}
                            counter={counter}
                            setMoamadootNoteId={setMoamadootNoteId}
                          />
                        ) : (
                          <ReadOnlyRows
                            moamadootNote={moamadootNote}
                            handleEditClick={handleEditClick}
                            increment={increment}
                            setMoamadootNoteId={setMoamadootNoteId}
                            setShowError={setShowError}
                            setErrorMessage={setErrorMessage}
                            setErrorHeader={setErrorHeader}
                          />
                        )}
                      </Fragment>
                    ))}
                  </tbody>
                </Table>
              </form>
            </Col>
          </Row>
        </div>
        <ErrorModal
          showError={showError}
          setShowError={setShowError}
          errorMessage={errorMessage}
          errorHeader={errorHeader}
        />
      </>
    );
  }
};
export default Listdelete;

const ReadOnlyRows = ({
  moamadootNote,
  handleEditClick,
  setMoamadootNoteId,
  increment,
  setShowError,
  setErrorMessage,
  setErrorHeader,
}) => {
  const [type, setType] = useState(null);
  const [id, setId] = useState(null);
  const [deleteObj, setDeleteObj] = useState(null);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);
  const [deleteMessage, setDeleteMessage] = useState(null);
  const axiosPrivate = useAxiosPrivate("application/json");
  const navigate = useNavigate();
  const location = useLocation();

  const showDeleteModal = (type, id, event) => {
    setType(type);
    setId(id);
    setDeleteObj(event);
    setDeleteMessage(
      `מחיקת ניסיון תעסוקתי "${moamadootNote.address}": האם אתה בטוח? `
    );
    setDisplayConfirmationModal(true);
  };

  // Hide the modal
  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    let isMounted = true;
    const controller = new AbortController();
    const delData = async () => {
      try {
        const response = await axiosPrivate.delete(
          baseURL + "moamadootnote/" + moamadootNote.id,
          {
            signal: controller.signal,
          }
        );
        if (isMounted) {
          increment();
          setMoamadootNoteId(null);
        }
      } catch (err) {
        if (err.response) {
          alert(HandleHttpErrors(err.response.status));
          if (err.response.status === 401) {
            navigate("/login", { state: { from: location }, replace: true });
          } else if (err.response.status === 403) {
            alert(HandleHttpErrors(err.response.status));
          }
          console.log(err.response);
        } else if (err.request) {
          alert(
            " The client never received a response, and the request was never left"
          );
          console.log(err.request);
        } else {
          console.log(err);
          alert(" Anything else");
        }
      }
    };

    delData();
  };

  return (
    <>
      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={handleDelete}
        hideModal={hideConfirmationModal}
        type={type}
        id={moamadootNote.id}
        event={deleteObj}
        message={deleteMessage}
      />
      <tr>
        <td>{moamadootNote.id}</td>
        <td>
          <GetParsedDate
            strDate={moamadootNote.log_created_at}
            withTime={true}
          />{" "}
        </td>
        <td>{moamadootNote.created_by_user}</td>
        <td>{moamadootNote.note}</td>

        <td>
          <button
            type="button"
            className="btn btn-success"
            onClick={(event) => handleEditClick(event, moamadootNote)}
            disabled={true}
          >
            <FiEdit2 />
          </button>
          <span> </span>

          <button
            type="button"
            className="btn btn-danger"
            onClick={(event) =>
              showDeleteModal("moamadootNote", moamadootNote.id, event)
            }
            disabled={true}
          >
            <FiTrash2 />
          </button>
        </td>
      </tr>
    </>
  );
};
